// Our coordinate reference system based on pixels
// Here we adjust the zoom level 1 to fit the screen on clients

	L.CRS.CustomZoom = L.extend({}, L.CRS.Simple, {
	    scale: function (zoom) {
			// Scale the viewport to the width/height of the screen
			var w = $('#background-map').width();
			var h = $('#background-map').height();
	
			var iW = 1980; // ToDo make this  a property of the Map or ImageOverlay layer to make it usable with other overlay sizes
	        var iH = 1355;
			var scale=1;
			if (zoom===0) return scale; // do nothing scale 1:1
	
	        if ((iW/iH)<(w/h)) // determine ratio to cover whole background
	        	scale= (1/(iW/w));
	        else 
	        	scale= (1/(iH/h));
	        	
			var quadTreeScale=Math.pow(2,zoom-1); // add normal scaling when zooming 
	
			return scale * quadTreeScale;
	    }
	});
	
	var MyPanControl = L.Control.extend({
	    options: {
	        position: 'topleft'
	    },
	
	    onAdd: function (map) {
	        // create the control container with a particular class name
	        var container = L.DomUtil.create('div', 'myPanControl hidden-xs');
	        
	        var N=L.DomUtil.create('div','',container);
	        $(N).html('N');
	        var up=L.DomUtil.create('span','mapPanUp clickable text-color-white glyphicon glyphicon-arrow-up',container);
	        
			
	        L.DomEvent
			.on(up, 'click', L.DomEvent.stopPropagation)
			.on(up, 'click', L.DomEvent.preventDefault)
			.on(up, 'dblclick', L.DomEvent.stopPropagation)
			.on(up, 'click', function(){
				
				$('.myPanControl').animateCSS('pulse');
				
		        var mapBounds=map.maxBounds; 
				
		        var northEast = L.latLng(mapBounds.getNorth(),mapBounds.getCenter().lng);
		        var southWest = L.latLng(mapBounds.getNorth(),mapBounds.getCenter().lng);
		        var bounds = L.latLngBounds(southWest, northEast);
				
				map.panInsideBounds(bounds); 
				
			}, map);
	        
	        
	        var middle=L.DomUtil.create('div','mapPanMiddle',container);
	        var W=L.DomUtil.create('span','',middle);
	        $(W).html('W');
	        var left=L.DomUtil.create('span','mapPanLeft clickable text-color-white glyphicon glyphicon-arrow-left',middle);
	
			L.DomEvent
			.on(left, 'click', L.DomEvent.stopPropagation)
			.on(left, 'click', L.DomEvent.preventDefault)
			.on(left, 'dblclick', L.DomEvent.stopPropagation)
			.on(left, 'click', function(){
				
				$('.myPanControl').animateCSS('pulse');
	
		        var mapBounds=map.maxBounds; 
				
		        var northEast = L.latLng(mapBounds.getCenter().lat,mapBounds.getWest());
		        var southWest = L.latLng(mapBounds.getCenter().lat,mapBounds.getWest());
		        var bounds = L.latLngBounds(southWest, northEast);
				
				map.panInsideBounds(bounds); 
				
			}, map);
			
	
	        var center=L.DomUtil.create('span','mapPanCenter clickable text-color-white glyphicon glyphicon-record',middle);
	        var southWest = L.latLng(0,-990);
	        var northEast = L.latLng(0,-990);
	        var bounds = L.latLngBounds(southWest, northEast);
			L.DomEvent
			.on(center, 'click', L.DomEvent.stopPropagation)
			.on(center, 'click', L.DomEvent.preventDefault)
			.on(center, 'dblclick', L.DomEvent.stopPropagation)
			.on(center, 'click', function(){
				$('.myPanControl').animateCSS('pulse');
		        var mapBounds=map.maxBounds; 			
				map.panTo(mapBounds.getCenter()); 
				
			}, map);		
			
	        var right=L.DomUtil.create('span','mapPanRight clickable text-color-white glyphicon glyphicon-arrow-right',middle);
		
	        L.DomEvent
			.on(right, 'click', L.DomEvent.stopPropagation)
			.on(right, 'click', L.DomEvent.preventDefault)
			.on(right, 'dblclick', L.DomEvent.stopPropagation)
			.on(right, 'click', function(){
				$('.myPanControl').animateCSS('pulse');
	
		        var mapBounds=map.maxBounds; 
				
		        var northEast = L.latLng(mapBounds.getCenter().lat,mapBounds.getEast());
		        var southWest = L.latLng(mapBounds.getCenter().lat,mapBounds.getEast());
		        var bounds = L.latLngBounds(southWest, northEast);
				
				map.panInsideBounds(bounds); 
				
			}, map);			
			
	        var E=L.DomUtil.create('span','',middle);
	        $(E).html('E');		
			
	        var down=L.DomUtil.create('span','mapPanDown clickable text-color-white glyphicon glyphicon-arrow-down',container);
	    
	        
			L.DomEvent
			.on(down, 'click', L.DomEvent.stopPropagation)
			.on(down, 'click', L.DomEvent.preventDefault)
			.on(down, 'dblclick', L.DomEvent.stopPropagation)
			.on(down, 'click', function(){
				
				$('.myPanControl').animateCSS('pulse');
				
		        var mapBounds=map.maxBounds;     
				
		        var northEast = L.latLng(mapBounds.getSouth(),mapBounds.getCenter().lng);
		        var southWest = L.latLng(mapBounds.getSouth(),mapBounds.getCenter().lng);
		        var bounds = L.latLngBounds(southWest, northEast);
				
				map.panInsideBounds(bounds); 
				
			}, map);			
						
	        var S=L.DomUtil.create('div','',container);
	        $(S).html('S');
	
			var back = L.DomUtil.create('div','mapBackSign',container);
			$(back).html('<div class="sign-text ">' + otuApp.translate.translate({'tag':'OP_MAP_SIGN_BACK'}) +'</div>');
			L.DomEvent
			.on(back, 'click', function() {
				/*
				var url=$(back).attr('data-back-url');
				if (typeof url!='undefined') {
					otuApp.triggerAjaxGet(url);
				}
				*/
				otuApp.pageNavigation.restoreTask();
			})
	        
	        // ... initialize other DOM elements, add listeners, etc.
	
	        return container;
	    }
	});



otuApp.backgroundMapDefaultOptions = {
	minZoom: 0,
	maxZoom: 1,
	center: [0, 0],
	zoom: 1,
	maxBoundsViscosity: 1.0,
	crs: L.CRS.CustomZoom,
	zoomControl:false,
	attributionControl:false,
	doubleClickZoom:false,
	touchZoom:false,
	scrollWheelZoom:false

};	

otuApp.markerBounceDefaultOptions= {};



otuApp.addBackgroundMap = function (map, options) {
	options.iW=1980;
	options.iH=1355;
	
	// calculate the edges of the image, in coordinate space, center is 0,0
	var southWest = map.unproject([-options.iW/2, options.iH/2], 0);
	var northEast = map.unproject([options.iW/2, -options.iH/2], 0);
	var bounds = new L.LatLngBounds(southWest, northEast);

	// add the image overlay, 
	// so that it covers the entire map
	//L.imageOverlay(options.url, bounds).addTo(map);

	map.myOverlays=[];
	map.myMapId=null;
	otuApp.setBackgroundMapOverlay(backgroundMap,{url:options.url,overlayID:0});
	otuApp.setBackgroundMapOverlay(backgroundMap,{url:options.url});		
	
	// tell leaflet that the map is exactly as big as the image
	map.setMaxBounds(bounds);
	map.maxBounds=bounds;
	
	// add a featuregroup to handle all the interaction layer
	map.myFeatures=L.featureGroup().addTo(map);
	map.myControls=[];
	
	// and when the screen changes reset the map scale/zoom, map.invalidateSize() does not work
	$( window ).resize(function() {
		map.invalidateSize(false);
	  	map.setZoom(0,{animate:false});
	  	map.setZoom(1,{animate:false});
	});
	
}

otuApp.testNewMap = function (map,options){
	if (typeof options.mapId==='undefined') return true;
	if (options.forceMapReload) {
		otuApp.clearMap(map);
		// console.log('Background Maps - map reload forced');
		return true;
	}
	if (map.myMapId===options.mapId) {
		return false;
	} else {
		return true;
	}
}

otuApp.setNewMap = function (map,options) {
	if (typeof options.mapId==='undefined') return false;
	map.myMapId=options.mapId;
	if ( typeof otuApp.appState.templateParams.backgroundMap!== 'undefined') otuApp.setBackgroundMapOverlay(backgroundMap, {force:true,url:otuApp.appState.rootUrl + otuApp.appState.templateParams.backgroundMap});

}

otuApp.setBackgroundMapOverlay = function (map, options) {
	// ToDo remove fixed width
	options.iW=1980;
	options.iH=1355;
	if (typeof options.overlayID==='undefined') options.overlayID=1;
	if (typeof options.queue==='undefined') options.queue=otuApp.fxQ;
	if (typeof options.force==='undefined') options.force=false;

	// calculate the edges of the image, in coordinate space, center is 0,0
	var southWest = map.unproject([-options.iW/2, options.iH/2], 0);
	var northEast = map.unproject([options.iW/2, -options.iH/2], 0);
	var bounds = new L.LatLngBounds(southWest, northEast);

	// add the image overlay, 
	if (typeof map.myOverlays[options.overlayID]==='undefined') {
		// add this new overlay layer with overlayID
		// preload the image and fade it in in the given otuApp.fxQ
		//$("<img />").attr('src', options.url).waitForImages(function() {
		otuApp.clearMap(map);
			options.queue.queue(function(next) {
				var overlay=L.imageOverlay(options.url, bounds, {opacity:0}).addTo(map);

				$(overlay._image).css({"display":"none"});
				overlay.setOpacity(1);
				$(overlay._image).fadeIn(otuApp.fxOptions.mapFadeInDuration);
				next();
				map.myOverlays[options.overlayID]= {overlay:overlay,url:options.url};
				// console.log('Background Maps - New Map Background Layer:' + options.overlayID + ' - ' + options.url);

			});

		//});

	} else {
		// # check if this overlay is alraedy set to the give background url
		if (map.myOverlays[options.overlayID].url!=options.url) {
			// console.log('Background Maps - Refreshing Map Background: ' + options.url);
			// console.log(options.url);
			// # store this new overlay layer in the map Object
			map.myOverlays[options.overlayID].url=options.url;
			
			//otuApp.clearMap(map);
			// # preload the image and fade Out fade In in in the given otuApp.fxQ
			//$("<img />").attr('src', options.url).waitForImages(function() {
				
				// # queue a function to fadeout the previous overlay and clear the markers/objects
				// # when we are forced we don't clear the map (use for refreshing screens with maps on, mostly development)
			
				/*
				options.queue.queue(function(otuApp.fxQNext) {
					// # fade out the markers/objects unless we are forced
					if (!options.force) $('.leaflet-marker-icon').fadeOut(otuApp.fxOptions.mapFadeOutDuration);
					$(map.myOverlays[options.overlayID].overlay._image).fadeOut(otuApp.fxOptions.mapFadeOutDuration, function(){
						// # clear all map objects unless we are forced
						if (!options.force) otuApp.clearMap(map);						
						otuApp.fxQNext();
					})
				});
				*/
				
				
				// # queue a function to fade in the new background
				options.queue.queue(function(fxQNext) {
					// # try add the layer on top
					
					// # Store the Previous Layer
					var previousOverlay=map.myOverlays[options.overlayID].overlay;
					
					// # Create the New Layer and Store it in the Map 
					var overlay=L.imageOverlay(options.url, bounds, {opacity:0}).addTo(map);
					overlay.setUrl(options.url);
					map.myOverlays[options.overlayID].overlay=overlay;

					
					// css Tweaks to the overlay
					$(overlay._image).css({"display":"none"});
					overlay.setOpacity(1);
					
					// # fade out the markers/objects 1st unless we are forced
					if (!options.force) $('.leaflet-marker-icon').fadeOut(otuApp.fxOptions.mapFadeOutDuration);
					// # clear all map objects unless we are forced
					
					// console.log('Background Maps - clearmap');
					if (!options.force) otuApp.clearMap(map);	
										
					// # Fadein the new overlay While the Previous one is below
					$(overlay._image).fadeIn(otuApp.fxOptions.mapFadeInDuration, function() {
						// # fade out the previous overlay now the new one is showing and no need to wait;
						

						$(previousOverlay._image).fadeOut(otuApp.fxOptions.mapFadeOutDuration, function(){
							
							// Remove the Previous Layer
							map.removeLayer(previousOverlay);
							
							// Fixed a bug where the polygons are not clickable, on leaflet stable;
							if (isDebugUser()) {
								for (let i = map.myOverlays.length-1; i >= 0; i--) { 
									map.myOverlays[i].overlay.bringToBack();
								}								
							}
							
						});
						fxQNext();

					});
					
					
					
					/*
					// # set the overlay
					map.myOverlays[options.overlayID].overlay.setUrl(options.url);
					// # fadein the new overlay
					$(map.myOverlays[options.overlayID].overlay._image).fadeIn(otuApp.fxOptions.mapFadeInDuration, function() {
						otuApp.fxQNext();
					});
					*/
			
				});	
			//}); // end preload	
		} // else console.log('Background Maps - Map Background already up to date');
	}	

}

otuApp.addClickTriggers = function (map) {
	map.myFeatures.eachLayer(function (layer) {
		if (typeof layer.options.triggerClick !== 'undefined') {
			layer.on('click', function(e) {	
				// console.log('Background Maps - Map click: ' + this.options.triggerClick);
				if ($('#' + this.options.triggerClick).hasAttr('data-link')) {
					var href=$('#' + this.options.triggerClick).attr('href');
					window.open(href);
				}
				$('#' + this.options.triggerClick).trigger('click');
			});
		}
	});
	
	otuApp.addPanningControls(map);
}

otuApp.addPanningControls = function (map) {
	var panControl = new MyPanControl();
	backgroundMap.addControl(panControl);
	map.myControls.push(panControl);		
}

otuApp.addHoverTriggers = function (map) {
	map.myFeatures.eachLayer(function (layer) {
		if (typeof layer.options.triggerHover !== 'undefined') {
			layer.on('mouseover', function(e) {	
				// console.log('Background Maps - Map mouseover: ' + this.options.triggerHover);
				$('#' + this.options.triggerHover).addClass('map-hovering');
			});
			layer.on('mouseout', function(e) {	
				// console.log('Background Maps - Map mouseout: ' + this.options.triggerHover);
				$('#' + this.options.triggerHover).removeClass('map-hovering');

			});
		}
	});
}

otuApp.addDrawControl = function (map , features) {
	
	if (typeof L.Control.Draw==='undefined') {
		console.log('Background Maps - !!! Attempting to access L.Draw.Control but not LOADED, refresh the page');
		return false;
	}
	
	// Add drawing and editing to map features
	function reportLayer(layer) {
		console.log('MAP: Report Layer');

		console.log(layer);

		var report='Background Maps - ReportLayer function says: Unknown feature...';
        if (layer.getLatLng) {
        	report=JSON.stringify(layer.getLatLng());
        }
        if (layer.getLatLngs ){
        	report=JSON.stringify(layer.getLatLngs());
        }
    	// console.log(report);
    	return report;
	}		
	var disableLinks = function (e) {
			e.preventDefault();
			return false;
	}
	
	// Initialise the draw control and pass it the FeatureGroup of editable layers
	var drawControl = new L.Control.Draw({
	    edit: {
	        featureGroup: features },
	    draw: {
	    	rectangle:false,
	    	circle:false
	    	
	    }, 
    	position:'bottomleft'    	
	});
	
	
	map.addControl(drawControl);
	map.myControls.push(drawControl);	
		
	// Report on layer after we Created them 
	map.on('draw:created', function (e) {
	    var type = e.layerType,
	        layer = e.layer;
	    features.addLayer(layer);
	    reportLayer(layer);
	});	
	
	// Report on layer after we edited them 
	map.on('draw:edited', function (e) {
	    var layers = e.layers;
	    layers.eachLayer(function (layer) {
		    reportLayer(layer);		        	
	    });
	});
	
	// Let is move link without following them
	map.on('draw:editstart', function (e) {
		$('a[data-ajax=true]').unbind('click');
		$('a[data-ajax=true]').bind('click',disableLinks);
		features.eachLayer(function (layer) {
			layer.on('click', function(){
				reportLayer(this);
			});
		});
		$('.map-div-icon').addClass('map-div-icon-important');

	});
	
	map.on('draw:editstop', function (e) {
		otuApp.registerAjaxHandlers();
		$('.map-div-icon').removeClass('map-div-icon-important');


	});	
}

otuApp.clearMap = function (map,Options) {
	var options={overlayID:1};
	$.extend(true,options,Options);
	
	if ((typeof map === 'undefined')) return;
	
	if (typeof map.myFeatures!='undefined') {
		// fade out the markers if we have some
		if ($('.leaflet-marker-icon').length) {
			map.myFeatures.clearLayers();
			//$('.leaflet-marker-icon').fadeOut(500, function() {
			//	map.myFeatures.clearLayers();
			//});
			
		} else map.myFeatures.clearLayers(); // a fallback clear layers
	}	
	
	if (typeof map.myControls!='undefined') {
	
		// remove all controls
		$.each(map.myControls, function (index, control) {
			map.removeControl(control);
		}); 
		map.myControls=[];
	
	}	

	map.myObjects=null;
	
	map.myMapId=null;
	/*
	if (typeof map.myOverlays!='undefined') {
		if (typeof map.myOverlays[options.overlayID] != 'undefined') map.myOverlays[options.overlayID].url = 'none';
	}
	*/
}

